import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCategoryOptions,
  getDataListByCategory,
  handleCategoryChange,
  handleDropdownToggle,
} from "../../../components/utils/helper";
import { AuthContext } from "../../../contexts/AuthProvider";
import DashboardMenu from "../DashboardMenu/DashboardMenu";
import "./styles.scss";

function EditTest() {
  const auth = useContext(AuthContext);
  const [category, setCategory] = useState("Select Category");
  const [options, setOptions] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [testsData, setTestsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    getCategoryOptions(
      setOptions,
      `${process.env.REACT_APP_API_URL}/api/test-categories`
    );
  }, []);

  useEffect(() => {
    getDataListByCategory(
      setTotalPages,
      setTestsData,
      `${process.env.REACT_APP_API_URL}/api/tests-lists/${activeCategory}/5/${currentPage}`
    );
  }, [activeCategory, currentPage]);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) {
      console.log(currentPage - 1);
      setCurrentPage(currentPage - 1);
    }
  };
  const edit = (testId) => {
    navigate(`/dashboard/test/edit/${testId}`);
  };

  const testDelete = async (testId) => {
    console.log("delete test");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/test/${testId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "api-key": process.env.REACT_APP_API_KEY,
            token: auth.token,
          },
        }
      );

      if (response.status !== 200) {
        return;
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="dashboard">
      <DashboardMenu />
      <div className="test-list__container">
        <div className="test-list__title">
          <h1 className="test-list__title__text">Edit Tests</h1>
        </div>
        <div className="category__container">
          <label className="category__label" htmlFor="category">
            Category:
          </label>
          <div className="dropdown">
            <button type="button" onClick={handleDropdownToggle}>
              {category}
            </button>
            <div className="dropdown-menu">
              {Array.isArray(options) &&
                options.map((option, index) => (
                  <button
                    key={option._id}
                    className="dropdown-item"
                    onClick={() =>
                      handleCategoryChange(
                        option,
                        setCategory,
                        setActiveCategory
                      )
                    }
                    type="button"
                  >
                    {option.rom}
                  </button>
                ))}
            </div>
          </div>
        </div>
        <div className="test-list__data">
          {testsData &&
            testsData.map((test) => (
              <>
                <div className="test-list__data-container">
                  <div className="test-list__data-item">
                    {`${test.order}.    ${test.name}`}
                  </div>
                  <div className="test-list__data-buttons">
                    <FontAwesomeIcon
                      className="test-list__data-buttons__edit"
                      icon={faEdit}
                      onClick={() => {
                        edit(test._id);
                      }}
                    />
                    <FontAwesomeIcon
                      className="test-list__data-buttons__delete"
                      icon={faTrash}
                      onClick={() => {
                        testDelete(test._id);
                      }}
                    />
                  </div>
                </div>
              </>
            ))}
        </div>
        <div className="test-list__buttons-container">
          <button
            className="test-list__buttons-container__button"
            onClick={prevPage}
          >
            Previous
          </button>
          <button
            className="test-list__buttons-container__button"
            onClick={nextPage}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTest;
